export default function getAkamaiVideoUrl(videoId) {
    return `https://image.hm.com/assets/hm/${videoId.substring(4, 6)}/${videoId.substring(6, 8)}/${videoId.replace('ref:', '')}.mp4`;
}
//# sourceMappingURL=getVideoUrlAkamai.js.map